import { observable } from 'mobx';
import BaseModalStore from '@src/components/modal-container/base-modal-store';

class RuleModalStore extends BaseModalStore {
  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }
  @observable
  text =
    '1.活动时间：即日起至2026年2月20日23:59\n' +
    '\n' +
    '2.登录方式：\n' +
    '①官方版本用户可使用金山通行证登录页面，或游戏内点击公告直接登录本页面。\n' +
    '②B站及应用宝渠道用户可通过游戏内点击公告直接登录本页面，敬请关注公告栏动态。' +
    '\n' +
    '\n' +
    '3.参与方式：\n' +
    '活动期间，在本活动页面完成对应任务即可获得抽奖机会，至多可获得16次抽奖机会。\n' +
    '①观看活动PV，可得1次机会\n' +
    '②完成关注官方B站账号，可得1次机会\n' +
    '③完成关注官方微博账号，可得1次机会\n' +
    '④完成每日分享页面，每日可分享一次，至多可得3次机会\n' +
    '⑤完成趣味H5网页活动《与你的爱之誓言》，可得1次机会\n' +
    '⑥1月29日限时活动开启后，在游戏内登录页面，共可得9次机会，具体规则如下：   \n' +
    '累计登录1天：1次\n' +
    '累计登录2天：1次\n' +
    '累计登录3天：2次\n' +
    '累计登录4天：2次\n' +
    '累计登录5天：3次\n' +
    '\n' +
    '4.奖品&中奖概率一览：\n' +
    '奖品1：全新限时售卖时装    0.002250% \n' +
    '奖品2：Steam Deck OLED 1TB    0.002250%\n' +
    '奖品3：天启者共鸣誓约*10    0.06300%\n' +
    '奖品4：随机特典明信片*1    0.157500%\n' +
    '奖品5：随机全新时装立牌*1    0.094500%\n' +
    '奖品6：随机亚克力流沙摆件*1    0.031500%\n' +
    '奖品7：数据金*50    0.270000%\n' +
    '奖品8：天启者心意补给    99.379000%\n' +
    '\n' +
    '5.发奖说明：\n' +
    '①实物奖励发放规则：a.抽中实物奖励的分析员，请务必在7日内填写完整收件信息，如未及时填写或信息不全导致奖励无法发放，则视为自动放弃奖励；收件信息一经提交不支持修改，请务必确认提交信息无误，若因用户个人问题造成快递退件、无法投递或者遗失的，不支持补寄；实物奖励将在活动结束后30个工作日内寄出。b.根据法律法规要求，抽中Steam Deck OLED 1TB奖励的分析员在填写完整收件信息后，需在中奖后15个工作日内通过微博/B站私信尘白禁区官方账号提供中奖截图，并提供与游戏内实名认证信息一致的本人有效身份证号，该信息仅用于为获奖者代扣代缴个人所得税，您需要向我们提供必要信息，否则我们将无法向您发放奖品；若存在身份信息变更等特殊情况，可在联系时同步向工作人员说明沟通；如未及时提供或信息不全导致奖励无法发放，则视为自动放弃奖励；该奖励将在活动结束后30个工作日内寄出。\n' +
    '②虚拟奖励发放规则：\n' +
    'a.对于已经有游戏账号的玩家，将通过游戏内邮件实时发送至游戏账号，由于游戏服务器波动影响，奖励发放可能存在延迟，请耐心等待。请确保参与抽奖活动的账号与游戏账号一致。\n' +
    'b.对于未创建角色的新用户，在活动期间前往游戏内创建角色，即可在游戏邮箱收到奖励，由于游戏服务器波动影响，奖励发放可能存在延迟，请耐心等待。\n' +
    'c.对于在活动结束后，创建角色的新用户，将无法收到奖励。\n' +
    '\n' +
    '③特殊奖励全新限时售卖时装发放规则：\n' +
    'a. 奖品包含2026年1月29日开启的限时活动【自往昔归还】期间供应站直售的全新系列时装（不包含相关拓展包），具体包含时装如下：缘音回响、纯白恋羽、霄倾君怀、祥云徜戏。\n' +
    'b. 该奖品属于虚拟奖品，请在中奖后提供中奖截图通过微博或B站私信尘白禁区官方账号确认信息，奖品将在联系官方帐号后三个工作日内通过游戏内邮件发放，请耐心等待。\n' +
    'c. 发放时，对中奖玩家已拥有的时装将按照供应站限时折扣售卖价格转换成比特金发放。\n' +
    '\n' +
    '6.本次活动主办方为尘白禁区。如有疑问，可登录游戏点击右上角设置-其他设置-联系客服。\n' +
    '\n' +
    '7.注意事项：   \n' +
    'a.根据有关法律法规，获奖用户可能需要自行完成纳税后续并承担相应费用；如根据法律法规要求，我们需要为获奖者代扣代缴个人所得税，您需要向我们提供必要信息，否则我们将无法向您发放奖品。 \n' +
    'b.特别提醒，本活动仅面向18岁以上成年人，如中奖者提供的身份信息经核实为未成年人（未满18周岁），主办方有权不予发放奖品，并视为该中奖者自动放弃奖励。该中奖资格将作废，主办方不承担任何责任。\n' +
    'c.抽中Steam Deck OLED 1TB奖励的分析员填写的中奖人信息应当与游戏账号实名信息一致，否则主办方有权取消中奖资格。\n' +
    'd.所有虚拟奖励仅限获奖用户自身使用，不可转让、不可出售、不可兑换为现金或实物。\n' +
    'e.如因用户违反游戏规则导致账号被封禁，在此期间无法领取或使用虚拟奖励的，由用户自行承担责任。\n' +
    '\n';
  use() {
    super.use();
  }
}

export default RuleModalStore;
